import React, { createContext, useContext, useState } from "react";


export const AuthContext = createContext({} as AuthContextType);

type AuthContextProviderProps = {
  children: React.ReactNode
}

type AuthContextType = {

  UserToken: {
    token: string,
    expiry: string,
    LoggedInUserId: string,
    Roles: string[],
    FirstName: string,
    LastName: string,
    Email: string

  }
  // setHotelId : React.Dispatch<React.SetStateAction<string>>
  setUserToken: (
    token: string,
    expiry: string,
    LoggedInUserId: string,
    Roles: string[],
    FirstName: string,
    LastName: string,
    Email: string
  ) => void


}


export const AuthProvider = ({ children }: AuthContextProviderProps) => {


        let  token_ = localStorage.getItem('Token');
        let  expiry_ = localStorage.getItem('Expiry');
        let  loggedInUserId_ = localStorage.getItem('LoggedInUserId');
        console.log('*** ',localStorage.getItem('UserRoles'));

        let  roles_  = [''];
        if(localStorage.getItem('UserRoles') !== null){
            roles_ = Array.from(localStorage.getItem('UserRoles')!.split(','));
            console.log('previos roles == ', roles_);
            
        }
        
        // Array.from(localStorage.getItem('UserRoles')!.split(','));
        let  firstName_ = localStorage.getItem('FirstName');
        let  lastName_ = localStorage.getItem('LastName');
        let  email_ = localStorage.getItem('Email');



  const [UserToken, setUser_Token] = useState({
    token: token_ ? token_ : '',
    expiry: expiry_ ? expiry_ : '',
    LoggedInUserId: loggedInUserId_ ? loggedInUserId_ : '',
    Roles: roles_ ? roles_ : [''],
    FirstName: firstName_ ? firstName_ : '',
    LastName: lastName_ ? lastName_ : '',
    Email: email_ ? email_ : ''

  })

  const setUserToken = (token: string, expiry: string, LoggedInUserId: string,
    Roles: string[], FirstName: string, LastName: string,
    Email: string) => {

    localStorage.setItem('Token', token);

    localStorage.setItem('Expiry', expiry);

    localStorage.setItem('LoggedInUserId', LoggedInUserId);

    localStorage.setItem('UserRoles', JSON.stringify(Roles));

    localStorage.setItem('FirstName', FirstName);
    localStorage.setItem('LastName', LastName);
    localStorage.setItem('Email', Email);

    setUser_Token({
      token: token,
      expiry: expiry,
      LoggedInUserId: LoggedInUserId,
      Roles: Roles,
      FirstName: FirstName,
      LastName: LastName,
      Email: Email
    })

  }

  return (
    <AuthContext.Provider value={{ UserToken, setUserToken }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)

